import { ISignedJobCard, JobCard } from '@job-card/models/job-card';
import { LeadRequestType } from '@leads/shared/models/domain/lead-request.domain';

export class ScheduledAssessment {
	id?: string;

	organisationId: string;
	organisationName: string;

	leadRequestId: string;
	leadRequestType: LeadRequestType;

	assignedEmployee: {
		userId: string;
		name: string;
	};

	selectedStartTime: Date;
	selectedEndTime: Date;

	whatsappNotes?: string;
	status: ScheduledAssessmentStatus;
	customerName: string;
	jobCard: JobCard;
	assessmentDetails: {
		serviceTypes: Array<string>;
		assessmentType?: ScheduledAssessmentType;
		callOutFee?: {
			amount: number;
			currency: string;
			includeInCommunication: boolean;
		};
		internalAssessmentNotes?: string;
		jobDescription: string;
	};
	signedJobCard: ISignedJobCard | null;
}

export enum ScheduledAssessmentType {
	ASSESSMENT = 'ASSESSMENT',
	JOB = 'JOB',
}

export enum ScheduledAssessmentStatus {
	// Initial
	REQUESTED = 'REQUESTED',

	// Customer Options
	SCHEDULED = 'SCHEDULED',
	DECLINED = 'DECLINED',

	// Owner Options
	CANCELLED = 'CANCELLED',

	// In Progress
	AWAITING_INVOICE = 'AWAITING_INVOICE',
	AWAITING_QUOTE = 'AWAITING_QUOTE',
	INVOICED = 'INVOICED',
	PARTIALLY_PAID = 'PARTIALLY_PAID',
	WORK_COMPLETED = 'WORK_COMPLETED',

	//Final
	COMPLETED = 'COMPLETED',
}

export const ScheduledAssessmentStatusLabels: { [key in ScheduledAssessmentStatus]: string } = {
	[ScheduledAssessmentStatus.REQUESTED]: 'Requested',
	[ScheduledAssessmentStatus.SCHEDULED]: 'Scheduled',
	[ScheduledAssessmentStatus.DECLINED]: 'Declined',
	[ScheduledAssessmentStatus.CANCELLED]: 'Cancelled',
	[ScheduledAssessmentStatus.AWAITING_INVOICE]: 'Awaiting Invoice',
	[ScheduledAssessmentStatus.AWAITING_QUOTE]: 'Awaiting Quote',
	[ScheduledAssessmentStatus.INVOICED]: 'Invoiced',
	[ScheduledAssessmentStatus.PARTIALLY_PAID]: 'Partially Paid',
	[ScheduledAssessmentStatus.WORK_COMPLETED]: 'Work Completed',
	[ScheduledAssessmentStatus.COMPLETED]: 'Completed',
};
